module.exports = __webpack_public_path__ + "static/media/lions-side.dfc6ce4b.png";